import {Link} from 'react-router-dom';
import {css, styled} from 'styled-components';

const getItemStyles = css<{$isLoading?: boolean}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  padding: 15px 18px 15px;
  background-color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.boxesModals : '#fff'};
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  min-height: 80px;
  max-height: 126px;

  ${({$isLoading}) =>
    $isLoading &&
    css`
      opacity: 0.5;
      cursor: progress;
    `}

  &:last-child {
    border-bottom: none;
  }
`;

export const Item = styled.div<{$isLoading?: boolean}>`
  ${getItemStyles};
`;

export const LinkItem = styled(Link)<{$isLoading?: boolean}>`
  ${getItemStyles};
  cursor: pointer;
`;
